import React from 'react'
import AddBtn from 'components/AddBtn'
import { Grid, TextField } from '@material-ui/core'

export default function Toolbar (props) {
  const { params, onParamsChange } = props

  return (
    <div className={'tool-bar'}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField name='moveResourceId' label='Move Resource ID' fullWidth variant='outlined' size='small' className='background-color' value={params.moveResourceId} onChange={event => onParamsChange({ moveResourceId: event.target.value }, 500)} />
        </Grid>

        <Grid item xs={3}>
          <TextField name='text' label='Text' fullWidth variant='outlined' size='small' className='background-color' value={params.text} onChange={event => onParamsChange({text: event.target.value}, 500)} />
        </Grid>

        <Grid container item xs={6} justifyContent={'flex-end'}>
          <AddBtn id='add-btn' color='primary' type='submit' variant='contained'
              onClick={e => {
                e.stopPropagation()
                props.history.push({ pathname: '', state: { params } })
              }}
          > TBD </AddBtn>
        </Grid>
      </Grid>
    </div>
  )
}
